<template>
  <div class="cont-box" v-loading="loading" element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.6)">
    <img class="title-header" src="../../assets/map-bg.png" />
    <header><span class="el-icon-back goBack" @click="$router.go(-1)"></span></header>
    <div>
      <div class="list">
        <div class="title-cont title-cont01">
          <img class="title-img" src="../../assets/b-title-des.png" />
          <p class="title" @click="$router.push({path: '/other/chart'})">{{month + '月' +province}}经营指标完成情况</p>
          <img class="title-img resever" src="../../assets/b-title-des.png" />
          <!-- <p class="time" v-if="data03[0].date">( 截止{{data03[0].date.substring(0, 4)+'.'+data03[0].date.substring(5, 7)+' )'}}</p> -->
        </div>
        <div class="echart-box">
          <Echart06 id="bg03" :datas="data03[0]" height="220px" />
          <Echart06 id="bg04" :datas="data03[1]" height="220px" />
          <Echart06 id="bg05" :datas="data03[2]" :reverse="true" height="220px" />
          <Echart06 id="bg06" :datas="data03[3]" height="220px" />
          <Echart06 id="bg07" :datas="data03[4]" height="220px" />
          <Echart0601 id="bg08" :datas="data03[5]" height="220px" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Echart06 from '../../components/Echart06.vue'
  import Echart0601 from '../../components/Echart0601.vue'
  export default {
    name: 'Target',
    components: {
      Echart06,
      Echart0601,
    },
    data() {
      return {
        province: null,
        month: null,
        loading: true,
        titles: ['经营数据分析', '销售数据分析'],
        curIndex: 0,
      }
    },
    mounted() {
      this.province = this.$route.params.id
      this.month = this.$route.query.month
    },
    computed: {
      data03() {
        let arr = this.$store.state.sellDataP.filter(item => {
          return item.province === this.province
        })
        if(!arr.length) return [{},{},{},{},{},{}]
        arr = arr[0].value
        console.log(arr)
        this.loading = false
        return [{
          name: '合同',
          Mb: arr.htMb,
          Sj: arr.htSj,
          Wcl: arr.htWcl,
          Lj: arr.htLj,
          Tq: arr.htTq
        }, {
          name: '回款',
          Mb: arr.hkMb,
          Sj: arr.hkSj,
          Wcl: arr.hkWcl,
          Lj: arr.hkLj,
          Tq: arr.hkTq
        }, {
          name: '费用',
          Mb: arr.fyMb,
          Sj: arr.fySj,
          Wcl: arr.fyWcl,
          Lj: arr.fyLj,
          Tq: arr.fyTq
        }, {
          name: '中标',
          Mb: arr.zbMb,
          Sj: arr.zbSj,
          Wcl: arr.zbWcl,
          Lj: arr.zbLj,
          Tq: arr.zbTq
        }, {
          name: '收入',
          Mb: arr.srMb,
          Sj: arr.srSj,
          Wcl: arr.srWcl,
          Lj: arr.srLj,
          Tq: arr.srTq
        }, {
          name: '应收账款',
          Lj: arr.ysLj,
        }]
      }
    },
    methods: {

    }
  }
</script>

<style scoped>
  .cont-box {
    background-color: #08103c;
    min-height: 100%;
  }

  .title-header {
    width: 100%;
  }

  .resever {
    transform: scaleX(-1);
  }

  .goBack {
    font-size: 16px;
    padding: 6px;
    color: #2dfcff;
    position: absolute;
    top: 10px;
    left: 10px;
    opacity: .8;
  }

  .title-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .title-img {
    width: 80px;
  }

  .title {
    color: #2dfcff;
    font-size: 16px;
    font-weight: bold;
    padding: 0 10px;
    white-space: nowrap;
  }

  .list {
    padding-bottom: 40px;
  }

  .icon-list {
    padding: 0 0 10px;
    display: flex;
    justify-content: center;
    margin: -10px 0 40px;
  }

  .icon {
    width: 40%;
    background: rgba(0, 0, 0, .2);
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid rgba(45, 252, 255, .2);
    font-size: 16px;
    font-weight: bold;
    padding: 10px 0;
    color: rgba(255, 255, 255, .6);
  }

  .icon-cur {
    color: white;
    background-color: #1fd6d9;
  }

  .title-cont01 {
    margin-bottom: 20px
  }

  .echart-box {
    display: flex;
    flex-wrap: wrap;
    padding: 0 10px;
  }

  .echart-box>div {
    width: 100%;
  }

  .time {
    position: absolute;
    top: 16px;
    left: 50%;
    transform: translateX(-50%);
    color: rgba(255, 255, 255, .6);
    font-size: 12px;
    padding: 6px;
  }
</style>
